{
  "entitySuggestion": {
    "duplicates": {
      "heading": {
        "system": "Ez a rendszer talán már létezik",
        "orgFunction": "Ez a Funkció talán már létezik"
      },
      "useThisInstead": {
        "system": "Ezt a rendszert használom",
        "orgFunction": "Ezt a Funkciót használom"
      },
      "reasons": {
        "same_category": "Azonos kategória",
        "same_department": "Azonos részleg"
      },
      "linkError": "A javaslat összekapcsolása nem sikerült. Kérjük, próbálja újra.",
      "checking": "Ismétlődések keresése…"
    },
    "kind": {
      "system": "Rendszer",
      "orgFunction": "Funkció"
    },
    "system": {
      "dialog": {
        "title": "Rendszer javaslása",
        "description": "Egy adminisztrátor felülvizsgálja a javaslatot és felveszi a rendszert.",
        "name": "Rendszer neve",
        "description_field": "Leírás",
        "category": "Kategória",
        "categoryHint": "Milyen rendszerről van szó leginkább? Pl. CRM / ERP / HCM",
        "url": "Link a szolgáltató webhelyére",
        "submit": "Javaslás"
      },
      "card": {
        "pendingBadge": "Javasolt"
      }
    },
    "orgFunction": {
      "dialog": {
        "team": {
          "title": "Csapat javaslása",
          "description": "Egy adminisztrátor felülvizsgálja a javaslatot és létrehozza a csapatot.",
          "name": "A csapat neve"
        },
        "role": {
          "title": "Funkció javaslása",
          "description": "Egy adminisztrátor felülvizsgálja a javaslatot és létrehozza a funkciót.",
          "name": "A funkció / a szerep / a csapat neve"
        },
        "description_field": "Leírás",
        "department": "Részleg",
        "departmentHint": "Melyik osztályba sorolható be legjobban a funkció?",
        "email": "E-mail",
        "submit": "Javaslás"
      },
      "card": {
        "pendingBadge": "Javasolt"
      }
    },
    "review": {
      "titleSystem": "Rendszerjavaslat áttekintése",
      "titleTeamSuggestion": "Csapatjavaslat áttekintése",
      "titleFunctionSuggestion": "Funkció-javaslat áttekintése",
      "descriptionSystem": "{{name}} felvétele új rendszerként a katalógusba, vagy egyesítés egy meglévő rendszerrel.",
      "descriptionTeamSuggestion": "{{name}} felvétele új csapatként a katalógusba, vagy egyesítés egy meglévő csapattal.",
      "descriptionFunctionSuggestion": "{{name}} felvétele új funkcióként a katalógusba, vagy egyesítés egy meglévő funkcióval.",
      "createAsNew": {
        "system": "Létrehozás új rendszerként",
        "team": "Létrehozás új csapatként",
        "function": "Létrehozás új funkcióként"
      },
      "titleApproveSystem": "Jóváhagyás és rendszer létrehozása",
      "titleApproveTeam": "Jóváhagyás és csapat létrehozása",
      "titleApproveFunction": "Jóváhagyás és funkció létrehozása",
      "descriptionApproveSystem": "{{name}} létrehozása új rendszerként és a javaslat jóváhagyása. A rá hivatkozó felvételek az új rendszerre fognak hivatkozni.",
      "descriptionApproveTeam": "{{name}} létrehozása új csapatként és a javaslat jóváhagyása. A rá hivatkozó felvételek az új csapatra fognak hivatkozni.",
      "descriptionApproveFunction": "{{name}} létrehozása új funkcióként és a javaslat jóváhagyása. A rá hivatkozó felvételek az új funkcióra fognak hivatkozni.",
      "approveAndCreate": "Jóváhagyás és létrehozás",
      "proposedDetails": {
        "headingSystem": "Javasolt rendszer",
        "headingTeam": "Javasolt funkció",
        "name": "Név",
        "kind": "Típus",
        "category": "Kategória",
        "url": "URL",
        "description": "Leírás",
        "department": "Részleg",
        "email": "E-mail"
      },
      "mergeWithExistingSection": {
        "system": "Egyesítés meglévő rendszerrel inkább",
        "orgFunction": "Egyesítés meglévő Funkcióval inkább"
      },
      "mergeSelectPlaceholder": {
        "system": "Válasszon meglévő rendszert…",
        "orgFunction": "Válasszon meglévő Funkciót…"
      },
      "confirmMerge": {
        "title": {
          "system": "Egyesítés meglévő rendszerrel?",
          "orgFunction": "Egyesítés meglévő Funkcióval?"
        },
        "description": {
          "system": "A(z) „{{suggestionName}}\" egyesítve lesz a(z) „{{targetName}}\" rendszerrel. A felvétel ezután a meglévő rendszerre fog hivatkozni. Ez a művelet nem vonható vissza.",
          "orgFunction": "A(z) „{{suggestionName}}\" egyesítve lesz a(z) „{{targetName}}\" Funkcióval. A felvétel ezután a meglévő Funkcióre fog hivatkozni. Ez a művelet nem vonható vissza."
        },
        "confirm": "Egyesítés"
      },
      "reject": "Elutasítás",
      "approved": "Javaslat jóváhagyva",
      "rejected": "Javaslat elutasítva",
      "merged": "Javaslat egyesítve",
      "sourceRecording": "Felvételben javasolva",
      "submittedBy": "Beküldte",
      "submittedAt": "Beküldve",
      "confirmReject": {
        "title": "Elutasítja a javaslatot?",
        "description": "A javaslat elutasításra kerül, és nem kerül be a tudásbázisba. Kérjük, adjon meg egy indokot."
      },
      "fields": {
        "rejectionReason": "Elutasítás indoka"
      },
      "placeholders": {
        "rejectionReason": "Röviden indokolja, miért utasítja el a javaslatot"
      }
    }
  }
}
